var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-list-item',{attrs:{"to":_vm.to,"two-line":"","link":"","exact":""}},[_c('v-list-item-title',[_vm._v(_vm._s(_vm.name))])],1),_c('v-divider')],1)}
var staticRenderFns = []

export { render, staticRenderFns }